<div class="modal-container relative p-xl">
  <div class="flex flex-col items-center text-center">
    <div class="flex text-info">
      <svg-icon key="warning-diamond" class="!text-2xl"></svg-icon>
    </div>
    <div class="mt-2xl text-base leading-base font-semibold">Your account has been updated.</div>
    <div class="mt-sm text-sm leading-sm">
      Please refresh to load the latest improvements and updates.
    </div>
    <div class="w-full flex flex-col md:flex-row-reverse items-center mt-xl"></div>
  </div>

  <div
    (click)="refresh()"
    class="w-full h-[36px] border border-primary rounded-sm flex items-center justify-center text-sm leading-sm text-primary cursor-pointer hover:border-info-dark hover:text-info-dark"
  >
    Refresh
  </div>
</div>
